import { render } from "./MobileProposalVote.vue?vue&type=template&id=8cce7a74"
import script from "./MobileProposalVote.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileProposalVote.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/MobileProposalVote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8cce7a74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8cce7a74', __exports__)) {
    api.reload('8cce7a74', __exports__)
  }
  
  module.hot.accept("./MobileProposalVote.vue?vue&type=template&id=8cce7a74", () => {
    api.rerender('8cce7a74', render)
  })

}


export default __exports__